var ActionStatus;
(function (ActionStatus) {
    ActionStatus["Idle"] = "idle";
    ActionStatus["Pending"] = "pending";
    ActionStatus["Success"] = "success";
    ActionStatus["Failed"] = "failed";
})(ActionStatus || (ActionStatus = {}));
var CheckoutSection;
(function (CheckoutSection) {
    CheckoutSection["Email"] = "email";
    CheckoutSection["Shipping"] = "shipping";
    CheckoutSection["Billing"] = "billing";
    CheckoutSection["PaymentMethod"] = "paymentMethod";
})(CheckoutSection || (CheckoutSection = {}));
var ShippingMethodCode;
(function (ShippingMethodCode) {
    ShippingMethodCode["StandardShipping"] = "standardshipping";
    ShippingMethodCode["FreeShipping"] = "freeshipping";
})(ShippingMethodCode || (ShippingMethodCode = {}));
var AddressType;
(function (AddressType) {
    AddressType["Shipping"] = "shipping";
    AddressType["Billing"] = "billing";
})(AddressType || (AddressType = {}));
var AddressShortType;
(function (AddressShortType) {
    AddressShortType["Shipping"] = "s";
    AddressShortType["Billing"] = "b";
})(AddressShortType || (AddressShortType = {}));
var ProcessHCResultStatus;
(function (ProcessHCResultStatus) {
    ProcessHCResultStatus["Waiting"] = "waiting";
    ProcessHCResultStatus["Fail"] = "fail";
    ProcessHCResultStatus["Success"] = "success";
})(ProcessHCResultStatus || (ProcessHCResultStatus = {}));

export { ActionStatus as A, CheckoutSection as C, ProcessHCResultStatus as P, ShippingMethodCode as S, AddressType as a, AddressShortType as b };
//# sourceMappingURL=checkout-Ee1eEXQH.js.map
